(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/search-results.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/search-results.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.SearchResults = Marionette.View.extend({
    template: function(data) {
      data = data || {};
      data.searchQuery = svs.grassroots.data.searchQuery || '';
      data.numberOfSearchResults =
        svs.grassroots.data.numberOfSearchResult || 0;
      return svs.grassroots.templates.search_results(data);
    },
    templateContext: {
      isCorporateSite: svs.grassroots.data.config.isCorporateSite
    },
    className: 'js-grassroots-search-wrapper bg-white grassroots-pop-up',
    collectionEvents: {
      change: 'render'
    },

    events: {
      'click .js-show-more': 'fetchMoreSearchResult',
      'click .js-search-close': 'closeSearchResults',
      'click .js-fetch-more-most-popular': 'renderMostPopularFetch',
      'click .js-fetch-more-most-popular-points': 'renderMostPopularPointsFetch'
    },
    renderMostPopularFetch: function() {
      setTimeout(function() {
        this.mostPopularView.render();
      }, 200);
    },
    renderMostPopularPointsFetch: function() {
      setTimeout(function() {
        this.mostPopularPointsView.render();
      }, 200);
    },
    regions: {
      receiverSearch: '#receiverSearch',
      receiverSearchResult: '#receiverSearchResult',
      myReceivers: '#myReceivers',
      lastPicked: '#lastPicked',
      mostPopular: '#mostPopular',
      mostPopularPoints: '#mostPopularPoints'
    },
    initialize: function() {
      var models;

      if (this.getOption('add') && this.getOption('name')) {
        models = svs.grassroots.collections.search_result.where({
          id: parseInt(this.getOption('add'), 10)
        });
        if (models.length) {
          svs.ui.loader.show();
          svs.grassroots.collections.my_receivers.addSupport(models[0], this.el);
        }
      }
    },

    onAttach: function() {
      var $body = $('body');
      var nav = $('.nav');
      var navAndHeaderHeight;
      if (
        (svs.core.detect.breakpoint.current === 'lg' ||
          svs.core.detect.breakpoint.current === 'xl') &&
        $body.hasClass('nav-top')
      ) {
        navAndHeaderHeight = $('#top-content').height() + nav.height();
      } else {
        navAndHeaderHeight = $('#top-content').height();
      }

      $('.js-grassroots-search-wrapper').css(
        'min-height',
        $body.height() - (navAndHeaderHeight + 24)
      );
      $body.scrollTop(0);
      $body.scrollLeft(0);
    },
    navigate: function(e) {
      if (e.currentTarget && e.currentTarget.getAttribute('data-url')) {
        var url = e.currentTarget
          .getAttribute('data-url')
          .substring(e.currentTarget.getAttribute('data-url').lastIndexOf('/'));
        svs.grassroots.router.navigate(url, {
          trigger: true,
          silent: false,
          replace: false
        });
        return false;
      }
      return true;
    },
    onRender: function() {
      this.showChildView(
        'receiverSearch',
        new svs.grassroots.views.SearchReceivers()
      );
      if (svs.grassroots.collections.search_result.length > 0) {
        this.searchResultView = new svs.grassroots.views.ReceiverSearchResult({
          collection: svs.grassroots.collections.search_result
        });
      } else {
        this.searchResultView = new svs.grassroots.views.ReceiverSearchEmpty();
      }
      this.showChildView('receiverSearchResult', this.searchResultView);
      if (!svs.core.detect.formfactor.mobile()) {
        if (!svs.grassroots.data.config.isCorporateSite) {
          this.showChildView(
            'myReceivers',
            new svs.grassroots.views.MyReceivers({
              model: new Backbone.Model({
                hasReceivers: svs.grassroots.data.hasReceivers ?
                  svs.grassroots.data.hasReceivers :
                  false
              }),
              collection: svs.grassroots.collections.my_receivers
            })
          );
        }
        this.showChildView(
          'lastPicked',
          new svs.grassroots.views.ReceiverToplistsLastPicked({
            collection: svs.grassroots.collections.lastPicked
          })
        );
        this.mostPopularView = new svs.grassroots.views.ReceiverToplistsMostPopular({
          model: new Backbone.Model({
            offsetPoints: 5,
            offsetSupporters: 5
          }),
          collection: svs.grassroots.collections.mostPopular
        });
        this.showChildView('mostPopular', this.mostPopularView);

        this.mostPopularPointsView = new svs.grassroots.views.ReceiverToplistsMostPopularPoints({
          model: new Backbone.Model({
            offsetPoints: 5,
            offsetSupporters: 5
          }),
          collection: svs.grassroots.collections.mostPopularPoints
        });
        this.showChildView('mostPopularPoints', this.mostPopularPointsView);
      }
    },
    fetchSearchResult: function(offset, limit) {
      offset = offset || 0;
      limit = limit || 5;
      var options = {
        method: 'GET',
        path: '/player/1/sponsorship/search'
      };
      var searchString = decodeURIComponent($('.js-show-more').data('query') || '');
      function singelSearch(model) {
        return new svs.grassroots.models.SingleSearchResult(model);
      }
      if (searchString.length > 0) {
        if (searchString && searchString.length > 0) {
          options.path =
            options.path +
            '?search=' +
            encodeURIComponent(searchString) +
            '&numResponses=' +
            limit +
            '&offset=' +
            offset;
          svs.ui.loader.show();
          svs.core.jupiter.call(
            options,
            function(result) {
              svs.grassroots.helpers.populateYearlyStatistics(result.receivers, function(receivers) {
                svs.ui.loader.hide();
                if (offset > 0) {
                  svs.grassroots.collections.search_result.add(_.map(receivers, singelSearch));
                  svs.grassroots.collections.search_result.trigger('append');
                } else {
                  svs.grassroots.collections.search_result.reset(_.map(receivers, singelSearch));
                }
                if (result.numberfound < offset + limit) {
                  $('.js-show-more-search-result').addClass('hide');
                } else {
                  $('.js-show-more-search-result').removeClass('hide');
                }
                return receivers;
              }, function(errorThrown) {
                svs.ui.loader.hide();
                svs.grassroots_logger.warn('Fetching search result failed: ' + errorThrown);
              });
            },
            function(xhr, textStatus, errorThrown) {
              svs.ui.loader.hide();
              svs.grassroots_logger.warn('Fetching search result failed: ' + errorThrown);
            }
          );
        }
      }
      return false;
    },
    fetchMoreSearchResult: function() {
      this.fetchSearchResult($('.search-result-receiver').length);
    },
    closeSearchResults: function() {
      window.location.href = svs.grassroots.data.config.grassrootsChooseClub;
    }
  });
})(Backbone, _, svs);


 })(window);